module.exports = __webpack_public_path__ + "img/28_54.890d2aa4.png";